import en from './en.json';
import id from './id.json';
import su from './su.json';
import ms from './ms.json';
import ar from './ar.json';
import ja from './ja.json';
import ko from './ko.json';
import zh from './zh.json';
import es from './es.json';

const dictionaries = { en, id, su, ms, ar, ja, ko, zh, es };
const supported = Object.keys(dictionaries);

class LocaleManager extends EventTarget {
  constructor() {
    super();
    const saved = localStorage.getItem('kips-design:locale');
    const browser = navigator.language?.split('-')[0] || 'en';
    this.locale = supported.includes(saved) ? saved : supported.includes(browser) ? browser : 'en';
    this.applyDocumentLanguage();
  }

  t(key, replacements = {}) {
    let value = dictionaries[this.locale]?.[key] ?? dictionaries.en[key] ?? key;
    for (const [name, replacement] of Object.entries(replacements)) {
      value = value.replaceAll(`{${name}}`, String(replacement));
    }
    return value;
  }

  setLocale(locale) {
    if (!supported.includes(locale) || locale === this.locale) return;
    this.locale = locale;
    localStorage.setItem('kips-design:locale', locale);
    this.applyDocumentLanguage();
    this.dispatchEvent(new Event('change'));
  }

  applyDocumentLanguage() {
    document.documentElement.lang = this.locale;
    document.documentElement.dir = this.locale === 'ar' ? 'rtl' : 'ltr';
  }

  formatNumber(value) {
    return new Intl.NumberFormat(this.locale).format(value);
  }

  getSupported() {
    return supported;
  }
}

export const localeManager = new LocaleManager();
export const t = (key, replacements) => localeManager.t(key, replacements);
